
import { useState } from 'react';

const ServicesSection = () => {
  const [selectedService, setSelectedService] = useState<number | null>(null);

  const services = [
    {
      title: '売買サポート',
      description: '地域相場を踏まえた価格査定から契約まで一貫対応。',
      image: 'https://public.readdy.ai/ai/img_res/73751c145b084c72fe519374f52d8b5d.jpg',
      icon: 'ri-home-line',
      details: {
        subtitle: '売却・購入をトータルサポート',
        features: [
          '無料査定・相場調査',
          '販売戦略の立案',
          '購入希望者のマッチング',
          '契約書類の作成・確認',
          '住宅ローンのご相談',
          'アフターフォロー'
        ],
        process: [
          'ご相談・物件査定',
          '販売活動・物件紹介',
          'ご契約・お手続き',
          'お引き渡し・アフターサポート'
        ]
      }
    },
    {
      title: '賃貸仲介',
      description: 'お部屋探しから入居まで、ライフスタイルに合った物件紹介。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20interior%20viewing%2C%20bright%20spacious%20living%20room%20with%20large%20windows%2C%20natural%20light%20streaming%20in%2C%20clean%20minimalist%20design%2C%20potential%20tenants%20looking%20around%2C%20professional%20real%20estate%20showing&width=400&height=300&seq=service-rental&orientation=landscape',
      icon: 'ri-key-line',
      details: {
        subtitle: 'お客様のライフスタイルに最適な住まい探し',
        features: [
          '豊富な物件データベース',
          'ライフスタイル診断',
          '内見のご案内',
          '賃貸契約のサポート',
          '入居後のトラブル対応',
          '更新・退去時のサポート'
        ],
        process: [
          'ご希望条件のヒアリング',
          '物件のご提案・内見',
          'ご契約・入居手続き',
          '入居後のサポート'
        ]
      }
    },
    {
      title: 'リフォーム・リノベーション',
      description: '暮らしに合わせた空間づくりを提案。施工会社とも連携。',
      image: 'https://readdy.ai/api/search-image?query=Home%20renovation%20and%20interior%20design%20consultation%2C%20modern%20kitchen%20and%20living%20space%20transformation%2C%20before%20and%20after%20concept%2C%20professional%20contractors%20and%20designers%20working%2C%20clean%20contemporary%20style&width=400&height=300&seq=service-renovation&orientation=landscape',
      icon: 'ri-hammer-line',
      details: {
        subtitle: '理想の住まいを実現するリフォーム・リノベーション',
        features: [
          '現地調査・プランニング',
          'デザイン提案・設計',
          '施工会社との連携',
          '工事進行管理',
          'アフターメンテナンス',
          '住宅ローン・補助金相談'
        ],
        process: [
          'ご相談・現地調査',
          'プラン提案・お見積り',
          'ご契約・工事開始',
          '完成・アフターサポート'
        ]
      }
    }
  ];

  const openModal = (index: number) => {
    setSelectedService(index);
  };

  const closeModal = () => {
    setSelectedService(null);
  };

  return (
    <>
      <section id="services-section" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 left-4 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-white text-xl`}></i>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <button 
                    onClick={() => openModal(index)}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer"
                  >
                    詳しく見る
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedService !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              {/* Header */}
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                      <i className={`${services[selectedService].icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900">
                        {services[selectedService].title}
                      </h2>
                      <p className="text-lg text-gray-600 mt-1">
                        {services[selectedService].details.subtitle}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={closeModal}
                    className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer"
                  >
                    <i className="ri-close-line text-xl text-gray-600"></i>
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* Image */}
                  <div>
                    <img 
                      src={services[selectedService].image}
                      alt={services[selectedService].title}
                      className="w-full h-64 object-cover object-top rounded-lg"
                    />
                  </div>

                  {/* Features */}
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4">
                      サービス内容
                    </h3>
                    <ul className="space-y-3">
                      {services[selectedService].details.features.map((feature, index) => (
                        <li key={index} className="flex items-center">
                          <i className="ri-check-line text-blue-600 mr-3"></i>
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Process */}
                <div className="mt-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-6">
                    ご利用の流れ
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    {services[selectedService].details.process.map((step, index) => (
                      <div key={index} className="text-center">
                        <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-3 font-bold">
                          {index + 1}
                        </div>
                        <p className="text-sm text-gray-700 font-medium">
                          {step}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* CTA */}
                <div className="mt-8 text-center bg-gray-50 rounded-lg p-6">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">
                    お気軽にご相談ください
                  </h4>
                  <p className="text-gray-600 mb-4">
                    専門スタッフがお客様のご要望に合わせて最適なプランをご提案いたします。
                  </p>
                  <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer">
                    <i className="ri-phone-line mr-2"></i>
                    無料相談のお申し込み
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServicesSection;
